var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "8xv632looa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D163",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFA440",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "fbf0aflwhb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D163",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFA440",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .852)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#8xv632looa)",
    strokeWidth: 1.175,
    fill: "#FFF",
    x: 0.587,
    y: 0.587,
    width: 88.825,
    height: 88.825,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.741 28.88h-5.64V27H34.543v1.879h-5.64c-1.128 0-1.88.75-1.88 1.878v4.508c0 4.32 3.196 7.889 7.52 8.453v.187c0 5.448 3.76 9.956 8.835 11.083l-1.316 3.944H37.74c-.752 0-1.504.564-1.692 1.315l-1.504 4.32H57.1l-1.503-4.32c-.188-.751-.94-1.315-1.692-1.315h-4.324l-1.316-3.944c5.076-1.127 8.835-5.635 8.835-11.083v-.187c4.324-.564 7.52-4.133 7.52-8.453v-4.508c0-1.127-.752-1.878-1.88-1.878zM34.543 39.962c-2.068-.564-3.76-2.442-3.76-4.696v-2.63h3.76v7.326zm15.039 5.823-3.76-2.066-3.76 2.066.94-3.757-2.82-3.757h3.948l1.692-3.756 1.692 3.756h3.948l-2.82 3.757.94 3.757zm11.28-10.519c0 2.254-1.693 4.32-3.76 4.696v-7.326h3.76v2.63z",
    fill: "url(#fbf0aflwhb)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.a5d55b0f2a4bf00e876b1d960f308d2a.svg";
export { ForwardRef as ReactComponent };